import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogue-departments',
  templateUrl: './catalogue-departments.component.html',
  styleUrls: ['./catalogue-departments.component.css']
})
export class CatalogueDepartmentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
